<form class="template-view" [formGroup]="createUpdateTemplateForm">
    <div class="heading" mat-dialog-title>
        <span>{{data?.heading}}</span>
        <button mat-icon-button (click)="cancel()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="template-body-container" mat-dialog-content>
        <div class="main-editor-area">
            <div class="input-fields">
                <mat-form-field floatLabel="always" appearance="outline"
                    [ngClass]="{'welcome-template-name': data?.templateType === 'WELCOME_TEMPLATE'}">
                    <mat-label>{{data?.templatePlaceholder}}</mat-label>
                    <input matInput placeholder="{{data?.templatePlaceholder}}" formControlName="templateName" required>
                </mat-form-field>

                <mat-form-field floatLabel="always" appearance="outline" class="template-subject"
                    *ngIf="data && data?.templateType === 'EMAIL_TEMPLATE'">
                    <mat-label>Email Subject</mat-label>
                    <input matInput placeholder="Enter email subject" formControlName="subject" required>
                </mat-form-field>
            </div>

            <div class="editor-wrapper">
                <mat-label class="field-label">Content</mat-label>
                <angular-editor formControlName="content" [config]="config"></angular-editor>
            </div>
        </div>

        <div class="placeholders-sidebar">
            <div class="sidebar-info">
                <div class="info-header">
                    <mat-icon>info_outline</mat-icon>
                    <span>Supported Placeholders</span>
                </div>
                <p class="info-desc">Click a placeholder to copy it to your clipboard.</p>
            </div>

            <div class="placeholders-list">
                <div class="placeholder-card" *ngFor="let v of variableDocs" (click)="copyToClipboard(v.token)">
                    <div class="card-top">
                        <span class="token-text">{{v.token}}</span>
                        <mat-icon class="copy-icon" [class.copied]="copiedToken === v.token">
                            {{copiedToken === v.token ? 'check' : 'content_copy'}}
                        </mat-icon>
                    </div>
                    <div class="card-bottom">
                        <span class="label-text">{{v.label}}:</span>
                        <span class="desc-text">{{v.description}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form-actions" mat-dialog-actions>
        <button mat-button class="cancel-btn" (click)="cancel()">Cancel</button>
        <button mat-raised-button class="save-btn" color="primary"
            (click)="data.update ? updateTemplate() : saveTemplate()" [disabled]="!createUpdateTemplateForm.valid">
            {{data.update ? 'Update' : 'Save'}}
        </button>
    </div>
</form>